export { default } from "./MainHero";
